<template>
<div class="posR">
	<Loading fillHeight="lastHeight" ref="Loading"></Loading>
	<div class="navBtn pl1x pr1x cb">
		<div class="tabBar style-tabBar fL active-c-main_E tra-fast_E mt0x">
			<button class="cSub" :class="{active:tabActive=='baseInfo'}" @click="tabActive='baseInfo'">{{getLanguageStr("word733","电站信息")}}</button>
			<button v-if="!stage.setting.loc.shieldBlackList.plantPhoto" class="cSub" :class="{active:tabActive=='photo'}" @click="tabActive='photo'" onclick="statistic('A35','A3502')">{{getLanguageStr('plant_detail12','照片')}}</button>
		</div>
		<button v-if="tabActive=='photo'&&(!finalOutRole||finalOutRole.indexOf('A1')!=-1)" v-permissions="'A/B/A3'" permission-type="none" class="bgContent sizeS pl05x pr05x cSub hover-main boxR shadowPublic fR" @click="newPhoto" type="button" onclick="statistic('A35','A3503')">{{$t('plant_detail14',['添加新照片'])}}</button>
	</div>
	<div class="mt05x" fillHeight="lastHeight" scroll>
		<div class="pb2x">
			<div v-if="tabActive=='baseInfo'&&baseInfo" class="ml1x mr1x">
				<div class="plantInfo panel bgPanel mt1x pb1x">
					 <!-- v-permissions="'A/B/F'" permission-type="none" -->
					<div class="title ">
						<span>{{getLanguageStr("word1642","基础信息")}}</span>
					</div>
					<ul class="viewBox lh20 ml1x mr1x w33pct_E dpIB_E textCut_E emptyToken_EE">
						<li>
							<span class="cSub pr1x" :title="$t('creat_plant17',['电站名称'])">{{$t("creat_plant17",["电站名称"])}}</span>
							<div class="txt">
								<span :title="baseInfo.station.name">{{baseInfo.station.name}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="$t('word848',['地址'])">{{$t("word848",["地址"])}}</span>
							<div class="txt">
								<span :title="baseInfo.station.location.address">{{baseInfo.station.location.address}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="getLanguageStr('word204+ID',['电站ID'])">{{getLanguageStr("word204+ID",["电站ID"])}}</span>
							<div class="txt">
								<span :title="baseInfo.station.id">{{baseInfo.station.id}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="$t('word1556',['建站日期'])">{{$t("word1556",["建站日期"])}}</span>
							<div class="txt">
								<span :title="timeFormat(baseInfo.station.createdDate,'utc','%Y/%m/%d',{offset:baseInfo.station.region.timezone})">{{timeFormat(baseInfo.station.createdDate,'utc','%Y/%m/%d',{offset:baseInfo.station.region.timezone})}}</span>
							</div>
						</li>
						<li v-if="getIn(baseInfo, ['station','region','nationId',]) == 15">
								<span :title="'NMI'" class="cSub pr1x">NMI</span>
								<div class="txt">
									<span :title="getIn(baseInfo, ['station', 'nmi'])"
										>{{
											getIn(baseInfo, ["station", "nmi"])
										}}</span
									>
								</div>
							</li>
						<li class="w100pct">
							<span class="cSub pr1x" :title="$t('word695',['位置'])">{{$t("word695",["位置"])}}</span>
							<div class="txt">
								<span :title="getLanguageStr('word839+:','经度:')+lngLatToTime(baseInfo.station.location.lng)+' '+getLanguageStr('word840+:','纬度:')+lngLatToTime(baseInfo.station.location.lat)">{{getLanguageStr('word839+:','经度:')+lngLatToTime(baseInfo.station.location.lng)+' '+getLanguageStr('word840+:','纬度:')+lngLatToTime(baseInfo.station.location.lat)}}</span>
							</div>
						</li>
						<li class="w100pct">
							<span class="cSub pr1x" :title="$t('word767',['电站时区'])">{{$t("word767",["电站时区"])}}</span>
							<div class="txt">
								<span :title="timeZoneList.length?timeZoneList[0].displayName:'--'">{{timeZoneList.length?timeZoneList[0].displayName:'--'}}</span>
							</div>
						</li>
					</ul>
				</div>
				<div class="plantInfo panel bgPanel mt15 pb1x">
					 <!-- v-permissions="'A/B/F'" permission-type="none" -->
					<div class="title">
						<span>{{getLanguageStr("word1718","系统信息")}}</span>
					</div>
					<ul class="viewBox lh20 ml1x mr1x w33pct_E dpIB_E textCut_E emptyToken_EE">
						<li v-if="powerType=='light'">
							<span class="cSub pr1x" :title="$t('word728',['电站类型'])">{{$t("word728",["电站类型"])}}</span>
							<div class="txt">
								<span :title="getTypeText(baseInfo.station.type,'plantType')">{{getTypeText(baseInfo.station.type,'plantType')}}</span>
							</div>
						</li>
						<li v-if="powerType=='light'">
							<span class="cSub pr1x" :title="$t('word736',['并网类型'])">{{$t("word736",["并网类型"])}}</span>
							<div class="txt">
								<span :title="getTypeText(baseInfo.station.gridInterconnectionType,'plantGridType')">{{getTypeText(baseInfo.station.gridInterconnectionType,'plantGridType')}}</span>
							</div>
							<!-- <span class="pr1x ">{{getTypeText(DetailInfo.gridInterconnectionType,'plantGridType')}}</span> -->
						</li>
						<li>
							<span class="cSub pr1x" :title="$t('word727',['装机容量'])">{{$t("word727",["装机容量"])}}</span>
							<div class="txt">
								<span :title="convertData(baseInfo.station.installedCapacity,2,'k','Wp')[0]">{{convertData(baseInfo.station.installedCapacity,2,"k",'Wp')[0]}}</span>
							</div>
						</li>
						<!-- 分布式自发自用余电上网 -->
						<li v-if="baseInfo.station.gridInterconnectionType=='EXCESS' &&  baseInfo.metering.theoryConsumeProportion !=null">
							<span class="cSub txt" :title="$t('word1477',['计划自发自用率'])">{{$t('word1477',['计划自发自用率'])}}</span>
							<span class="pr1x" :title="floatFix(baseInfo.metering.theoryConsumeProportion,2,'%')">{{floatFix(baseInfo.metering.theoryConsumeProportion,2,"%")}}</span>
						</li>
						<li v-if="powerType=='light'">
							<span class="cSub pr1x" :title="$t('word770',['方位角'])">{{$t("word770",["方位角"])}}</span>
							<div class="txt">
								<span :title="floatFix(baseInfo.station.installationAzimuthAngle,2,'°')">{{floatFix(baseInfo.station.installationAzimuthAngle,2,'°')}}</span>
							</div>
						</li>
						<li v-if="powerType=='light'">
							<span class="cSub pr1x" :title="$t('word759',['倾角'])">{{$t("word759",["倾角"])}}</span>
							<div class="txt">
								<span :title="floatFix(baseInfo.station.installationTiltAngle,2,'°')">{{floatFix(baseInfo.station.installationTiltAngle,2,'°')}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="getLanguageStr('word1478','投产日期')">{{getLanguageStr('word1478','投产日期')}}</span>
							<div class="txt">
								<span>{{timeFormat(baseInfo.station.startOperatingTime,'utc','%Y/%m/%d',{offset:baseInfo.station.region.timezone})}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="getLanguageStr('word1711','投产状态')">{{getLanguageStr('word1711','投产状态')}}</span>
							<div class="txt">
								<span v-if="Number(timeFormat(baseInfo.station.startOperatingTime,'utc','%Y%m%d',{offset:baseInfo.station.region.timezone}))<=Number(timeFormat(new Date(),'utc','%Y%m%d',{offset:baseInfo.station.region.timezone}))">{{getLanguageStr('word1491','已投产')}}</span>
								<span v-else>{{getLanguageStr('word1492','未投产')}}</span>
							</div>
						</li>
					</ul>
				</div>
				<div class="plantInfo panel bgPanel mt15 pb1x">
					 <!-- v-permissions="'A/B/F'" permission-type="none" -->
					<div class="title">
						<span>{{getLanguageStr("word1702","收益信息")}}</span>
					</div>
					<ul class="viewBox lh20 ml1x mr1x w33pct_E dpIB_E textCut_E emptyToken_EE">
						<li>
							<span class="cSub pr1x" :title="$t('word1555',['货币单位'])">{{$t("word1555",["货币单位"])}}</span>
							<div class="txt">
								<span :title="baseInfo.finance.currency=='CNY'&&stage.languageId=='zh'?'元':baseInfo.finance.currency">{{baseInfo.finance.currency?baseInfo.finance.currency=="CNY"&&stage.languageId=='zh'?"元":baseInfo.finance.currency:'--'}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="$t('plant_detail283',['度电收益'])">{{$t("plant_detail283",["度电收益"])}}</span>
							<div class="txt">
								<span :title='baseInfo.finance.mergeElectricPrice'>{{baseInfo.finance.mergeElectricPrice!=null?baseInfo.finance.mergeElectricPrice:'--'}} {{baseInfo.finance.mergeElectricPrice!=null?baseInfo.finance.currency =='CNY'&&stage.languageId=='zh'? '元/kWh':baseInfo.finance.currency+'/kWh':''}}</span>
							</div>
							<!-- <span class="pr1x ">{{getTypeText(DetailInfo.gridInterconnectionType,'plantGridType')}}</span> -->
						</li>
						<li>
							<span class="cSub pr1x" :title="$t('word1281',['总成本'])">{{$t("word1281",["总成本"])}}</span>
							<div class="txt">
								<span :title="convertData(baseInfo.finance.constructionCost,2,'',baseInfo.finance.currency)[0]">{{convertData(baseInfo.finance.constructionCost,2,'',baseInfo.finance.currency)[0]}}</span>
							</div>
						</li>
					</ul>
				</div>
				<div class="plantInfo panel bgPanel mt15 pb1x">
					 <!-- v-permissions="'A/B/F'" permission-type="none" -->
					<div v-if="JSON.stringify(baseInfo) !='{}'">
						<div class="title">
							<span>{{getLanguageStr("word731","业主信息")}}</span>
						</div>
						<ul class="viewBox lh20 ml1x mr1x w33pct_E dpIB_E textCut_E emptyToken_EE">
							<li>
								<span class="cSub pr1x" :title="$t('word1704',['业主姓名'])">{{$t("word1704",["业主姓名"])}}</span>
								<div class="txt">
									<span :title='baseInfo.station.ownerName'>{{baseInfo.station.ownerName?baseInfo.station.ownerName:'--'}}</span>
								</div>
							</li>
							<li>
								<span class="cSub pr1x" :title="$t('word1617',['业主联系电话'])">{{$t("word1617",["业主联系电话"])}}</span>
								<div class="txt">
									<span :title='baseInfo.station.contactPhone'>{{baseInfo.station.contactPhone?baseInfo.station.contactPhone:''}}</span>
								</div>
								<!-- <span class="pr1x ">{{getTypeText(DetailInfo.gridInterconnectionType,'plantGridType')}}</span> -->
							</li>
							<li>
								<span class="cSub pr1x" :title="$t('word1705',['业主工作单位'])">{{$t("word1705",["业主工作单位"])}}</span>
								<div class="txt">
									<span :title='baseInfo.station.ownerCompany '>{{baseInfo.station.ownerCompany?baseInfo.station.ownerCompany:'--' }}</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="plantInfo panel bgPanel mt15 pb1x">
					<div class="title">
						<span>{{getLanguageStr("manage302","管理者信息")}}</span>
					</div>
					<ul class="viewBox lh20 ml1x mr1x w33pct_E dpIB_E textCut_E emptyToken_EE">
						<li>
							<span class="cSub pr1x" :title="$t('word774',['管理者'])">{{$t("word774",["管理者"])}}</span>
							<div class="txt">
								<span v-if="baseInfo.powerStationUserorOrg.organization" :title="(baseInfo.powerStationUserorOrg.orgName||'--')+'('+$t('word1650',['商家'])+')'">{{baseInfo.powerStationUserorOrg.orgName||'--'}} ({{$t("word1650",["商家"])}})</span>
								<span v-else :title="(baseInfo.powerStationUserorOrg.userName||'--')+'('+$t('word1546',['用户'])+')'">{{baseInfo.powerStationUserorOrg.userName||'--'}} ({{$t("word1546",["用户"])}})</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="baseInfo.powerStationUserorOrg.organization?$t('word1656',['联系人姓名']):$t('word67',['姓名'])">{{baseInfo.powerStationUserorOrg.organization?$t('word1656',['联系人姓名']):$t('word67',['姓名'])}}</span>
							<div class="txt">
								<span :title="baseInfo.powerStationUserorOrg[baseInfo.powerStationUserorOrg.organization?'adminName':'userName']||'--'">{{baseInfo.powerStationUserorOrg[baseInfo.powerStationUserorOrg.organization?'adminName':'userName']||'--'}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="$t('word658',['手机号'])">{{$t('word658',['手机号'])}}</span>
							<div class="txt">
								<span :title="baseInfo.powerStationUserorOrg[baseInfo.powerStationUserorOrg.organization?'adminPhone':'userPhone']||'--'">{{baseInfo.powerStationUserorOrg[baseInfo.powerStationUserorOrg.organization?'adminPhone':'userPhone']||'--'}}</span>
							</div>
						</li>
						<li>
							<span class="cSub pr1x" :title="$t('word68',['邮箱'])">{{$t('word68',['邮箱'])}}</span>
							<div class="txt">
								<span :title="baseInfo.powerStationUserorOrg[baseInfo.powerStationUserorOrg.organization?'adminEmail':'userEmail']||'--'">{{baseInfo.powerStationUserorOrg[baseInfo.powerStationUserorOrg.organization?'adminEmail':'userEmail']||'--'}}</span>
							</div>
						</li>
					</ul>
				</div>
			</div><!--baseInfo end-->
			<div v-if="tabActive=='photo'">
				<NoData v-if="photoList&&photoList.length==0" :txt="doPermissions('A/B/A3')&&(!finalOutRole||finalOutRole.indexOf('A1')!=-1)?'':getLanguageStr('phrase390','当前没有数据诶')" fillHeight="lastHeight,-space,-space">
					<button v-if="!finalOutRole||finalOutRole.indexOf('A1')!=-1" v-permissions="'A/B/A3'" permission-type="none" class="bgContent bdSub pl05x pr05x sizeM boxR hover-main" @click="newPhoto" type="button" onclick="statistic('A35','A3503')">{{$t('plant_detail13',['点击这里添加照片'])}}</button>
				</NoData>
				<div class="photoList taC cb ml1x_E mt1x_E fL_E">
					<button v-for="(li,index) in photoList" :key="index" class="boxR bgContent tra-fast hover-c-main" :title="li.description" @click="()=>{viewPhoto(index)}" type="button" onclick="statistic('A35','A3504')">
						<div :style="{'background-image':'url('+li.url+')'}" class="cover dpB boxR-top"></div>
						<div class="name h3x-lh textCut" :title="li.name">{{li.name}}</div>
					</button>
				</div>
			</div><!--safe box end-->
		</div>
	</div><!--scroll end-->
</div>
</template>
<script>
import { mapGetters } from 'vuex'

import Loading from '@/components/common/ui/Loading'
import NoData from '@/components/common/ui/NoResult'
import ViewPhoto from '@/components/common/viewPhoto/Index.vue'
import NewEdit from '@/components/common/viewPhoto/NewEdit.vue';

import * as lib from '@/util/lib.js'
import {apiGetPlantDetail,apiGetPlantPhotoList} from '@/api/maintain/plant/list';
import {dictListTimezone} from '@/api/base.js'
export default {
	components: {Loading,NoData},
	props:{
    powerType:{//能源类型light,wind
      type:String,
      default:"light"
    },
     roleCode: {
      type: Array,
			default: () => {
      return []
      }
    },
		finalOutRole:{//外部权限列表
			type:Array,
			default:null
		}
	},
	data () {
		return {
			option:{
				plantId:null
			},
			baseInfo:null,//保存电站信息数据
			photoList:null,//保存照片列表数据
			stage,
			timeZoneList:[],
			tabActive:"baseInfo",//photo
			// result.finance:{},
			// result.metering:{}
		}
	},
	watch:{
		tabActive:function(val){
			switch(val){
				case "baseInfo":
					if(!this.baseInfo){
						this.getAllgetBaseInfo(this.option.plantId);
					}
					break;
				case "photo":
					if(!this.photoList){
						this.getPhotoList(this.option.plantId);
					}
					this.$nextTick(()=>{
						lib.fillHeight();
					});
					break;
			}
		}
		// result.station(data){
		// 	this.isEmpty = _.isEmpty(data)
		// 	lib.loadingChange($("#plantInfo [loading]"),"false");
		// },
		// result.finance(data){
		// 	this.isCost = _.isEmpty(data)
		// 	lib.loadingChange($("#plantInfo [loading]"),"false");
		// }
	},
	computed: {
		// operatingType(startSec){
		// 	let date=[new Date(startSec),new Date()];
		// 	if(this.result.station.startOperatingTime>new Date().getTime()){
		// 		return true
		// 	}else{
		// 		return false
		// 	}
		// }
	},
	methods: {
		getLanguageStr,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		getTypeText: lib.getTypeText,
		timeFormat: lib.timeFormat,
		doPermissions:lib.doPermissions,
		lngLatToTime: function (data) { // 经纬度转换为时间
			if ($.isNumeric(data)) {
				let arr = new Array(3)
				arr[0] = parseInt(data)
				arr[1] = lib.floatFix((Math.abs(data - arr[0])) * 60,0,null,false);
				arr[2] = lib.floatFix(((Math.abs(data - arr[0])) * 60 - parseInt((Math.abs(data - arr[0])) * 60)) * 60, 2)
				return arr[0] + '°' + arr[1] + '′' + arr[2] + '″'
			}
		},
		// mz(data){
		// 	return "UTC"+mz.tz(data).format("Z")
		// },
		show(data){
			lib.fillHeight();
			this.option.plantId=data.stationId;
			this.getAllgetBaseInfo(data.stationId);
		},

		getAllgetBaseInfo(id){
			this.$refs.Loading.show()
			Promise.all([this.getBaseInfo(id), this.getTimeZoneList()]).then(res => {
				this.$refs.Loading.hide()
				// this.timeZoneList=res[1]
				this.timeZoneList = res[1].filter(el => el.code == res[0].station.region.timezone)
				this.baseInfo = res[0]
			}, error => {
				this.$refs.Loading.hide()
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		getTimeZoneList () {
			return new Promise((resolve, reject) => {
				let qc = {lan: stage.languageId}
				dictListTimezone(qc).then((success) => {
					// console.log(success)
					resolve(success)
				}, error => {
					reject(error)
				})
			})
		},
		getBaseInfo(id){
			return new Promise((resolve, reject) => {
				apiGetPlantDetail(id, {language: stage.languageId}).then(response => {
					resolve(response)
				}, error => {
					reject(error)
				})
			})
		},
		getPhotoList:function(id){//获取电站照片列表
			apiGetPlantPhotoList(id).then(success=>{
				// $.each(new Array(50),index=>{
				// 	success.data.push({
				// 		id:index,
				// 		url:'https://www.music-bazaar.com/album-images/vol7/446/446066/2259914-big/Music-Deluxe-Edition-cover.jpg',
				// 		name:index+" 啊可塑剂的哈克塑料袋和iuoweghfibnfjm,不是可交互当否阿恢复我安慰热步步高",
				// 		description:"iosuhf更深刻几年后管理局东方红郡返回空温哥华人iobfmnbvliosuhf更深刻几年后管理局东方红郡返回空温哥华人iobfmnbvliosuhf更深刻几年后管理局东方红郡返回空温哥华人iobfmnbvliosuhf更深刻几年后管理局东方红郡返回空温哥华人iobfmnbvliosuhf更深刻几年后管理局东方红郡返回空温哥华人iobfmnbvliosuhf更深刻几年后管理局东方红郡返回空温哥华人iobfmnbvliosuhf更深刻几年后管理局东方红郡返回空温哥华人iobfmnbvl;sdkjh就"
				// 	});
				// });
				this.photoList=success.data;
				this.$nextTick(()=>{
					lib.fillHeight();
				});
			},error=>{
				this.$refs.Loading.hide();
			});
		},
		newPhoto:function(){
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],NewEdit,
				{plantId:this.option.plantId},
				{
					Close:[this.onPhotoClose.bind(this)],
				},{}
			).then(({instance, childInstance}) => {
				childInstance.show("new",instance);
			});
		},
		viewPhoto:function(index){//查看照片
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],ViewPhoto,
				{id:this.id,fromPart:"plant",finalOutRole:this.finalOutRole,roleCode:this.roleCode},
				{
					Close:[this.onPhotoClose.bind(this)],
					Delete:[this.onDelete.bind(this)]
				},{}
			).then(({instance, childInstance}) => {
				childInstance.show(this.photoList,index,instance);
			});
		},
		onDelete:function(index){
			this.photoList.splice(index,1);
			this.$nextTick(()=>{
				lib.fillHeight();
			});
		},
		onPhotoClose:function(needUpdatePhotoList){//查看照片关闭
			if(needUpdatePhotoList){
				this.getPhotoList(this.option.plantId);
			}
		},
		getIn: function (state, array, initial = null) {
			let obj = Object.assign({}, state);

			for (let i = 0; i < array.length; i++) {
				// when is undefined return init immediately
				if (typeof obj !== "object" || obj === null) {
					return initial;
				}
				const prop = array[i];
				obj = obj[prop];
			}
			if (obj === undefined || obj === null) {
				return initial;
			}
			return obj;
		},
	},
	mounted(){
		statistic('A35','A3501')
		lib.setScroll($(this.$el).find('[scroll]'));
	}
}
</script>

<style lang="scss" scoped>
.inline{display: inline-block;}
.plantInfo .title{
	 padding: 1rem;
	 font-size: inherit;
	 span{
		 font-size:1.2em
	 }
}
.txt{
		display: inline;
}
.photoList{
	>*{width:12em;box-shadow:0 0 0 rgba(#000,0);
		&:hover{@extend %boxShadowHigh;}
	}
	.cover{height:12em;background:center;background-size:cover;}
	.name{}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationInfo.vue